/**
 * Account created event - tracks when a user successfully creates an account.
 *
 * @example Usage (preferred)
 * const { trackEvent } = useCohesion()
 *
 * trackEvent(EventCreators.accountCreated({
 *   userContext: {
 *     anonymousId: 'officia aliquip culpa quis Ut',
 *     correlationId: 'do velit',
 *     instanceId: 'aute exercitation',
 *     sessionId: 'qui'
 *   },
 *   customerId: 'culpa aliquip qui',
 *   acquisitionSource: 'TPG Newsletter',
 *   acquisitionSourceId: 'form123',
 *   hashedEmail: 'ut nulla ad Excepteur Ut',
 *   authenticationLevel: 'ACCOUNT'
 * }))
 */

import { z } from 'zod';

import { defineEvent } from '../event-factory';

export default defineEvent({
  eventName: 'core.AccountCreated.v1',

  // What data this event needs (see schema link for full details)
  // https://app.make.rvohealth.com/schemas/sch_1hulWdoQa8UqkYF4UhibG94HHUk
  cohesionSchema: {
    userContext: z.object({
      anonymousId: z.string(),
      correlationId: z.string().optional(),
      instanceId: z.string().optional(),
      sessionId: z.string().optional(),
    }),
    customerId: z.string().optional(),
    acquisitionSource: z.string().optional(),
    acquisitionSourceId: z.string().optional(),
    hashedEmail: z.string().optional(),
    authenticationLevel: z.string().optional(),
  },

  tealiumMethodType: 'link',
});
